import React, { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid2'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import { AiOutlineLogin } from 'react-icons/ai'
import { AiOutlineLogout } from 'react-icons/ai'
import { IoNotificationsSharp } from 'react-icons/io5'
import { IoPersonCircleSharp } from 'react-icons/io5'
import defaultTexts from '../../texts/texts'
import constants from '../../config/constants'
import { request } from '../../_network/request'
import { setAccountBalance } from '../../store/reducers/profileSlice'
import { clientAccountsURLs } from '../../_network/apiUrls'
import { userLogout } from '../../_network/auth'
import logo from '../../assets/images/logo.png'
import HeaderMenuItem from './HeaderMenuItem'
import CustomPopover from './CustomPopover'
import useWindowDimensions from './WindowDimesnions'
import BalanceWrapper from './BalanceWrapper'
import CustomDialog from './CustomDialog'
import CustomTextField from './_form_fields/CustomTextField'
import PaypalWrapper from './paypal/PaypalWrapper'

const paypalOptions = {
  'client-id': constants.paypalClientId,
  currency: constants.paypalCurrency,
  intent: 'capture',
}

const balanceRefreshInterval = 60000

const Header = (props) => {
  const { setLoginDialogOpen, setSignUpDialogOpen, supportedPaymentMethods } = props
  const theme = useTheme()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { width } = useWindowDimensions()

  const isAuthenticated = useSelector(state => state.profile.isAuthenticated)
  const account_id = useSelector(state => state.profile.account_id)
  const account_balance = useSelector(state => state.profile.account_balance)

  const [forceClosePopover, setForceClosePopover] = useState(false)
  const [refillBalanceDialogOpen, setRefillBalanceDialogOpen] = useState(false)
  const [payResultDialogOpen, setPayResultDialogOpen] = useState(false)
  const [payResultText, setPayResultTexs] = useState('')
  const [amount, setAmount] = useState('')
  const [oldBalance, setOldBalance] = useState(account_balance)
  const [refillBalanceData, setRefillBalanceData] = useState(null)
  const [fetchBalanceCount, setFetchBalanceCount] = useState(1)

  const wrapperStyle = {
    minHeight: '70px',
    background: theme.palette.aliceBlue,
    padding: '0px 20px',
  }

  const logoStyle = {
    cursor: 'pointer',
  }

  const loginButtonStyle = {
    textTransform: 'capitalize',
    fontWeight: '400',
    color: 'white',
    background: theme.palette.oxfordBlue,
    fontSize: '22px',
    height: '50px',
    borderRadius: '25px',
    padding: '0px 40px',

    '&:hover': {
      background: alpha(theme.palette.oxfordBlue, 0.8),
    },
  }

  const signUpButtonStyle = {
    textTransform: 'capitalize',
    fontWeight: '400',
    color: 'white',
    background: theme.palette.violetsAreBlue,
    fontSize: '22px',
    height: '50px',
    borderRadius: '25px',
    padding: '0px 40px',

    '&:hover': {
      background: alpha(theme.palette.violetsAreBlue, 0.8),
    },
  }

  const iconStyle = {
    color: theme.palette.violetsAreBlue,
  }

  const fieldBoxStyle = {
    padding: '12px 0px'
  }

  const formControlStyle = {
    background: theme.palette.aliceBlue,
    color: theme.palette.vodka,
    borderRadius: '5px',
    width: '100%',
  }

  const outlinedInputStyle = {
    '& .MuiInputBase-input::label': {
      color: theme.palette.vodka,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.vodka,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.vodka,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.vodka,
    },
  }

  const currencyLabelStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '18px',
    fontWeight: '500',
    paddingTop: '15px',
    textTransform: 'uppercase',
  }

  // const creditCardButtonStyle = {
  //   textTransform: 'capitalize',
  //   fontWeight: '500',
  //   color: 'white',
  //   background: theme.palette.pictonBlue,
  //   fontSize: '18px',
  //   width: '100%',
  //   height: '50px',
  //   borderRadius: '25px',
  //   padding: '0px 10%',
  //   marginBottom: '20px',

  //   '&:hover': {
  //     background: alpha(theme.palette.pictonBlue, 0.8),
  //   },
  // }

  const notAuthenticatedMenu = [
    {
      label: defaultTexts.products,
      submenu: [
        {
          label: defaultTexts.openStackSolutionKit,
          navigation: '/products/openstack-solution-kit'
        },
        {
          label: defaultTexts.iSender,
          navigation: '/products/isender'
        },
      ],
    },
    // {
    //   label: defaultTexts.features,
    //   elementId: 'id_features',
    // },
    // {
    //   label: defaultTexts.prices,
    //   elementId: 'id_prices',
    // },
    {
      label: defaultTexts.contact,
      elementId: 'id_contact',
    },
  ]

  const authenticatedMenu = [
    {
      label: defaultTexts.products,
      submenu: [
        {
          label: defaultTexts.openStackSolutionKit,
          navigation: '/openstack-solution-kit'
        },
        {
          label: defaultTexts.iSender,
          navigation: '/isender'
        },
      ],
    },
    {
      label: defaultTexts.subscriptions,
      navigation: '/subscriptions',
    },
    {
      label: defaultTexts.users,
      navigation: '/users',
    },
    {
      label: defaultTexts.docs,
      navigation: '/docs',
    },
  ]

  const getCurrencyCode = (currency) => {
    let currency_code = ''

    supportedPaymentMethods.forEach(pm => {
      if (pm.currencies && pm.currencies.length > 0) {
        pm.currencies.forEach(cu => {
          if (currency.toUpperCase() === cu.name.toUpperCase()) {
            currency_code = cu.code
          }
        })
      }
    })

    return currency_code
  }

  const handleClickLogo = () => {
    navigate('/')
    // dispatch(subscriptionAddReset())
  }

  const handleClickLoginButton = () => {
    setLoginDialogOpen(true)
  }

  const handleClickSignUpButton = () => {
    setSignUpDialogOpen(true)
  }

  const handleClickLogoutButton = () => {
    userLogout()
    navigate('/')
  }

  const handleClickProfile = () => {
    navigate('/profile')
    setForceClosePopover(true)
  }

  const handleClickNotifications = () => {
    navigate('/notifications')
    setForceClosePopover(true)
  }

  const handleRefillBalanceDialogOpen = () => {
    setRefillBalanceDialogOpen(true)

    if (setForceClosePopover) {
      setForceClosePopover(true)
    }
  }

  const handleRefillBalanceDialogClose = () => {
    setRefillBalanceDialogOpen(false)
    setAmount('')
  }

  const handlePayResultDialogOpen = (text) => {
    setPayResultDialogOpen(true)
    setPayResultTexs(text)
  }

  const handlePayResultDialogClose = () => {
    setPayResultDialogOpen(false)
    setPayResultTexs('')
  }

  const handleChangeAmount = (event) => {
    const value = event.target.value

    if (value && value.match(/^[0-9]*\.?[0-9]*$/)) {
      setAmount(parseFloat(value))
    }
  }

  const fetchBalance = useCallback( async () => {
    const url = constants.core_service_domain + '/' + clientAccountsURLs.getProfile      
    const request_data = { url, method: 'GET' }    
    const response = await request(request_data)

    if (response && response.status_code && response.status_code < 400 && response.data) {
      dispatch(setAccountBalance({ account_balance: response.data.account_balance }))
    }
  }, [dispatch])

  const onSuccessfulPayment = (paymentDetails) => {
    setAmount('')
    setOldBalance(account_balance)
    handleRefillBalanceDialogClose()
    handlePayResultDialogOpen(defaultTexts.refillBalanceSuccessfullText)

    const payment_amount = paymentDetails.purchase_units[0].amount.value
    const payment_currency = paymentDetails.purchase_units[0].amount.currency_code
    const payment_currency_code = getCurrencyCode(paymentDetails.purchase_units[0].amount.currency_code)
    
    const postData = {
      client_id: account_id,
      amount: payment_amount,
      currency: payment_currency,
      currency_code: payment_currency_code,
      payment_method: 'paypal',
      transaction_data: paymentDetails,
    }
    
    setRefillBalanceData(postData)
  }

  const onFailedPayment = () => {
    setAmount('')
    handleRefillBalanceDialogClose()
    handlePayResultDialogOpen(defaultTexts.paymentFailedText)    
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setFetchBalanceCount(prev => prev + 1)
    }, balanceRefreshInterval)
    
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    if (oldBalance === account_balance && isAuthenticated) {
      fetchBalance()
    }    
  }, [fetchBalance, fetchBalanceCount, oldBalance, account_balance, isAuthenticated])

  useEffect(() => {
    const balanceRefillRequest = async (postData) => {
      const url = constants.core_service_domain + '/' + clientAccountsURLs.getBalanceRefill      
      const request_data = { url, method: 'POST', data: postData }
      await request(request_data)
      setRefillBalanceData(null)
    }

    if (refillBalanceData) {
      balanceRefillRequest(refillBalanceData)
    }
  }, [refillBalanceData])

  const getMenu = () => {
    const menu = isAuthenticated ? authenticatedMenu : notAuthenticatedMenu

    return (
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        alignItems={{ xs: 'flex-start', lg: 'center' }}
        justifyContent='flex-start'
        spacing={2}
        sx={{ width: '100%' }}
      >
        {
          menu.map((item, index) => (
            <HeaderMenuItem key={index} {...item} setForceClosePopover={setForceClosePopover} />
          ))
        }
      </Stack>
    )
  }

  const getMenuElement = () => {
    return (
      <>
        {
          width >= constants.lgBreakpoint ?
          <>{getMenu()}</> :
          <CustomPopover
            type='menu'
            forceClosePopover={forceClosePopover}
            setForceClosePopover={setForceClosePopover}
            sx={iconStyle}
          >
            {getMenu()}
          </CustomPopover>
        }
      </>
    )
  }

  return (
    <Box sx={wrapperStyle}>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{ width: '100%', minHeight: '70px', }}
      >
        <Box>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='flex-start'
            spacing={{ xs: 1, lg: 3 }}
            sx={{ width: '100%' }}
          >
            <Box sx={logoStyle} onClick={handleClickLogo}>
              <img src={logo} alt='' />
            </Box>
            <Box>{ isAuthenticated && getMenuElement() }</Box>
          </Stack>
        </Box>
        <Box>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='flex-end'
            spacing={ isAuthenticated ? 1 : { xs: 1, lg: 3 } }
            sx={{ width: '100%' }}
          >
            {
              isAuthenticated ?
              <>
                {
                  width >= constants.lgBreakpoint ?
                  <>
                    <BalanceWrapper
                      handleRefillBalanceDialogOpen={handleRefillBalanceDialogOpen}
                    />
                    <IconButton sx={iconStyle} onClick={handleClickNotifications}>
                      <IoNotificationsSharp />
                    </IconButton>
                    <IconButton sx={iconStyle} onClick={handleClickProfile}>
                      <IoPersonCircleSharp />
                    </IconButton>
                  </> :
                  <CustomPopover
                    type='settings'
                    forceClosePopover={forceClosePopover}
                    setForceClosePopover={setForceClosePopover}
                    sx={iconStyle}
                  >
                    <BalanceWrapper
                      isMobile={true}
                      handleRefillBalanceDialogOpen={handleRefillBalanceDialogOpen}
                    />
                    <Divider />
                    <Box sx={{ padding: '10px 0px', cursor: 'pointer' }} onClick={handleClickNotifications}>
                      <Stack
                        direction='row'
                        alignItems='center'
                        justifyContent='flex-start'
                        spacing={1}                        
                      >
                        <Box sx={iconStyle}>
                          <IoNotificationsSharp size={32} />
                        </Box>
                        <Box sx={{ fontSize: '18px' }}>{defaultTexts.notifications}</Box>
                      </Stack>                      
                    </Box>
                    <Divider />
                    <Box sx={{ padding: '10px 0px', cursor: 'pointer' }} onClick={handleClickProfile}>
                      <Stack
                        direction='row'
                        alignItems='center'
                        justifyContent='flex-start'
                        spacing={1}                        
                      >
                        <Box sx={iconStyle}>
                          <IoPersonCircleSharp size={32} />
                        </Box>
                        <Box sx={{ fontSize: '18px' }}>{defaultTexts.account}</Box>
                      </Stack>                      
                    </Box>
                  </CustomPopover>
                }
                <IconButton sx={iconStyle} onClick={handleClickLogoutButton}>
                  <AiOutlineLogout />
                </IconButton>
              </> :
              <>
                <Box>{getMenuElement()}</Box>
                {
                  width >= constants.lgBreakpoint &&
                  <Button
                    variant='text'
                    disableRipple
                    disableElevation
                    sx={signUpButtonStyle}
                    onClick={handleClickSignUpButton}
                  >
                    {defaultTexts.signUp}
                  </Button>
                }

                {
                  width >= constants.lgBreakpoint ?
                  <Button
                    variant='text'
                    disableRipple
                    disableElevation
                    sx={loginButtonStyle}
                    onClick={handleClickLoginButton}
                  >
                    {defaultTexts.login}
                  </Button> :
                  <IconButton sx={iconStyle} onClick={handleClickLoginButton}>
                    <AiOutlineLogin />
                  </IconButton>
                }
              </>
            }
          </Stack>
        </Box>
      </Stack>

      <CustomDialog
        open={refillBalanceDialogOpen}
        onClose={handleRefillBalanceDialogClose}
        dialogTitle={{
          title: defaultTexts.refillYourBalance,
          sx: {
            color: theme.palette.violetsAreBlue,
            fontSize: '22px',
            fontWeight: '500',
          },
        }}
        closeIconColor={theme.palette.violetsAreBlue}
			>
        <Box sx={fieldBoxStyle}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 9, lg: 10 }}>
              <CustomTextField 
                variant='outlined'
                label={defaultTexts.amount}
                currentValue={amount}
                setCurrentValue={handleChangeAmount}
                sx={formControlStyle}
                outlinedInputSx={outlinedInputStyle}
              />
            </Grid>
            <Grid size={{ xs: 3, lg: 2 }}>
              <Box sx={currencyLabelStyle}>USD</Box>
            </Grid>
          </Grid>          
        </Box>

        <Box sx={fieldBoxStyle}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 9, lg: 10 }}>
              {/* <Button
                variant='text'
                disableRipple
                disableElevation
                sx={creditCardButtonStyle}
              >
                {defaultTexts.creditCard}
              </Button> */}
              {
                (amount && parseFloat(amount) > 0) &&
                <PaypalWrapper
                  amount={amount}
                  paypalOptions={paypalOptions}
                  onSuccess={onSuccessfulPayment}
                  onFail={onFailedPayment}
                />
              }
            </Grid>
          </Grid>  
        </Box>
      </CustomDialog>

      <CustomDialog
        open={payResultDialogOpen}
        onClose={handlePayResultDialogClose}
        dialogTitle={{ title: defaultTexts.payment }}
        dialogBody={{ text: payResultText }}
			/>
    </Box>
  )
}

export default Header